import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export type OnboardingStepActionsProps = {
  canGoBack?: boolean
  onBack?: () => void
  backDisabled?: boolean
  /** Primary forward action. Ignored when `actions` is set. */
  onContinue?: () => void
  continueDisabled?: boolean
  continueLabel?: string
  continueBusyLabel?: string
  isBusy?: boolean
  /** Extra controls immediately before the primary continue button (e.g. Skip). */
  trailing?: ReactNode
  /** Fully custom right-side cluster; replaces continue button + trailing. */
  actions?: ReactNode
  className?: string
}

/** Standard Back + Continue row for onboarding and org-setup wizard steps. */
export function OnboardingStepActions({
  canGoBack = false,
  onBack,
  backDisabled = false,
  onContinue,
  continueDisabled = false,
  continueLabel = 'Continue',
  continueBusyLabel = 'Continuing…',
  isBusy = false,
  trailing,
  actions,
  className,
}: OnboardingStepActionsProps) {
  const hasBack = canGoBack && onBack

  return (
    <div className={cn('flex items-center justify-between gap-2', className)}>
      {hasBack ? (
        <Button variant="outline" onClick={onBack} disabled={backDisabled}>
          Back
        </Button>
      ) : (
        <span aria-hidden />
      )}
      {actions ?? (
        <div className="flex items-center gap-2">
          {trailing}
          {onContinue ? (
            <Button onClick={onContinue} disabled={continueDisabled}>
              {isBusy ? continueBusyLabel : continueLabel}
            </Button>
          ) : null}
        </div>
      )}
    </div>
  )
}
